import React from 'react'
import { IconButton, Stack, Typography, useTheme } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';

export default function CompanyInfoItem({ title, capitalize = true, value, showEditIcon = true, onClickEdit, showError = false }) {

  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const error = showError && !Boolean(value);

  return (
    <Stack>
      <Stack
        style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
        className="!my-[12px]"
      />
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
        >
          <Typography
            className="fs-12 ff-Roboto fw-regular !capitalize"
            color={error ? '#CF1010' : textLight}
            style={{ minWidth: '130px' }}
          >
            {title}
          </Typography>
          <Typography
            className={`fs-16 ff-Roboto fw-regular !ml-[64px] ${capitalize ? 'capitalize' : ''}`}
            color={text}
          >
            {value || '-'}
          </Typography>
        </Stack>
        {showEditIcon && <IconButton  onClick={() => onClickEdit()}>
          <EditIcon style={{ transform: 'scale(1.143)', color: textLight, width: '18px', height: '18px' }} />
        </IconButton>}
      </Stack>
    </Stack>
  )
}
